import React from "react";
import BaseIconButton, { BaseIconButtonProps } from "./BaseIconButton";
import RightIcon from "react-icons/lib/md/chevron-right";

type Props = BaseIconButtonProps;

export function NextButton(props: Props) {
  return (
    <BaseIconButton rightIcon={<RightIcon />} {...props}>
      {props.children}
    </BaseIconButton>
  );
}
